import React from 'react';

import Cloud from './Cloud';
import DayWeek from './DayWeek';
import Temperature from './Temperature';

const Weather = (props) => {
  const { weather, lang } = props.info;

  const day1 = weather[1];
  const day2 = weather[2];
  const day3 = weather[3];

  return (
    <div>
      <div className="weather-3days">
        <div className="weather-3days__day">
          <DayWeek data={{ day: day1.datetime, langDay: lang }} />
          <Temperature
            info={{
              temp: (day1.app_max_temp + day1.app_min_temp) / 2,
              class: 'temperature temperature_small',
            }}
          />
          <Cloud
            info={{ icon: day1.weather.icon, class: 'cloud cloud_small' }}
          />
        </div>
        <div className="weather-3days__day">
          <DayWeek data={{ day: day2.datetime, langDay: lang }} />
          <Temperature
            info={{
              temp: (day2.app_max_temp + day2.app_min_temp) / 2,
              class: 'temperature temperature_small',
            }}
          />
          <Cloud
            info={{ icon: day2.weather.icon, class: 'cloud cloud_small' }}
          />
        </div>
        <div className="weather-3days__day">
          <DayWeek data={{ day: day3.datetime, langDay: lang }} />
          <Temperature
            info={{
              temp: (day3.app_max_temp + day3.app_min_temp) / 2,
              class: 'temperature temperature_small',
            }}
          />
          <Cloud
            info={{ icon: day3.weather.icon, class: 'cloud cloud_small' }}
          />
        </div>
      </div>
    </div>
  );
};

export default Weather;
